import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    padding: theme.spacing(4, 4, 0, 4),
    whiteSpace: 'nowrap',
  },
  resizeFontTextField: {
    width: 255,
    '& .MuiInputBase-input': {
      fontSize: '14px',
    },
    '& .MuiInputLabel-formControl': {
      fontSize: '14px',
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
    },
  },
  defaultValueWidth: {
    width: '220px',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '200px',
  },
  submitButton: {
    marginRight: theme.spacing(3),
  },
  reviewRoot: {
    boxSizing: 'border-box',
    backgroundColor: theme.palette.bg.main,
    padding: theme.spacing(10),
  },
}))
